import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SimpleLayoutComponent } from './layouts/simple-layout/simple-layout.component';
import { SidebarLayoutComponent } from './layouts/sidebar-layout/sidebar-layout.component';
import { CustomRoute } from './shared/types/route.type';
import { AuthGuard } from './guards/auth.guard';
import {
  ROUTE_AUTH,
  ROUTE_GRADEBOOK,
  ROUTE_GROUP,
  ROUTE_HOME,
  ROUTE_STUDENT_GROUPS,
  ROUTE_LECTURER,
  ROUTE_USER,
  ROUTE_ASSESSMENT_PACKAGE,
  ROUTE_EXCUSED_ABSENCES,
  ROUTE_STUDENTS,
  ROUTE_SCHEDULE_EXCEPTIONS,
  ROUTE_SEMESTERS,
  ROUTE_ANALYTICS,
} from './shared/consts/routes.const';
import { Page404Component } from './layouts/components/page404/page404.component';
import { PrintLayoutComponent } from './layouts/print-layout/print-layout.component';

const routes: CustomRoute[] = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: ROUTE_HOME,
  },
  {
    path: '',
    component: SimpleLayoutComponent,
    children: [
      {
        path: ROUTE_AUTH,
        loadChildren: () => import('./pages/auth/auth.module').then((m) => m.AuthModule),
        data: {
          title: 'Авторизация',
        },
      },
    ],
  },
  {
    path: 'print',
    component: PrintLayoutComponent,
    children: [
      {
        path: '',
        loadChildren: () => import('./pages/print/print.module').then((m) => m.PrintModule),
      },
    ],
  },
  {
    path: '',
    component: SidebarLayoutComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: ROUTE_HOME,
        loadChildren: () => import('./pages/timetable/timetable.module').then((m) => m.TimetableModule),
        data: {
          title: 'Расписание',
          breadcrumb: 'Расписание',
        },
      },
      {
        path: ROUTE_USER,
        loadChildren: () => import('./pages/user/user.module').then((m) => m.UserModule),
        data: {
          title: 'Пользователи',
          breadcrumb: 'Пользователи',
        },
      },
      {
        path: ROUTE_GROUP,
        loadChildren: () => import('./pages/group/group.module').then((m) => m.GroupModule),
        data: {
          title: 'Группы',
          breadcrumb: 'Группы',
        },
      },
      {
        path: ROUTE_GRADEBOOK,
        loadChildren: () => import('./pages/grades-journal/grades-journal.module').then((m) => m.GradesJournalModule),
        data: {
          title: 'Электронный журнал',
          breadcrumb: 'Электронный журнал',
          fullHeight: true,
          fullWidth: true,
        },
      },
      {
        path: ROUTE_STUDENT_GROUPS,
        loadChildren: () => import('./pages/student-groups/student-groups.module').then((m) => m.StudentGroupsModule),
        data: {
          title: 'Студенческие группы',
          breadcrumb: 'Студенческие группы',
        },
      },
      {
        path: ROUTE_STUDENTS,
        loadChildren: () => import('./pages/students/students.module').then((m) => m.StudentsModule),
        data: {
          title: 'Студенты',
          breadcrumb: 'Студенты',
        },
      },
      {
        path: ROUTE_ASSESSMENT_PACKAGE,
        loadChildren: () =>
          import('./pages/assessment-packages/assessment-package.module').then((m) => m.AssessmentPackageModule),
        data: {
          title: 'Комплекс контрольных мероприятий',
          breadcrumb: 'Комплекс контрольных мероприятий',
        },
      },
      {
        path: ROUTE_EXCUSED_ABSENCES,
        loadChildren: () =>
          import('./pages/excused-absences/excused-absences.module').then((m) => m.ExcusedAbsencesModule),
        data: {
          title: 'Уважительные причины',
          breadcrumb: 'Уважительные причины',
        },
      },
      {
        path: ROUTE_SCHEDULE_EXCEPTIONS,
        loadChildren: () =>
          import('./pages/schedule-exceptions/schedule-exceptions.module').then((m) => m.ScheduleExceptionsModule),
        data: {
          title: 'Перенос занятий',
          breadcrumb: 'Перенос занятий',
        },
      },
      {
        path: ROUTE_LECTURER,
        loadChildren: () => import('./pages/lecturer/lecturer.module').then((m) => m.LecturerModule),
        data: {
          title: 'Лекторы',
          breadcrumb: 'Лекторы',
        },
      },
      {
        path: ROUTE_SEMESTERS,
        loadChildren: () => import('./pages/semester/semester.module').then((m) => m.SemesterModule),
        data: {
          title: 'Семестр',
          breadcrumb: 'Семестр',
        },
      },
      {
        path: ROUTE_ANALYTICS,
        loadChildren: () => import('./pages/analytics/analytics.module').then((m) => m.AnalyticsModule),
        data: {
          title: 'Аналитика',
          breadcrumb: 'Аналитика',
          fullHeight: true,
          fullWidth: true,
        },
      },
    ],
  },
  // 404
  {
    path: '**',
    component: Page404Component,
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
